import React, { useEffect, useCallback, useMemo } from 'react'
import { Pagination } from 'react-bootstrap';
import './paging.component.scss';
import { SelectBox } from 'devextreme-react';

const PagingComponent = (props: ItemListProps) => {

    const [pageSizeList, setPageSizeList] = React.useState<Array<{ "name": number }>>([{ "name": 10 }, { "name": 25 }, { "name": 50 }, { "name": 100 }]);
    const [pageSize, setPageSize] = React.useState();
    const defaultPageSize = 10;
    const pageSizeLst = useMemo(() => [{ "name": 10 }, { "name": 25 }, { "name": 50 }, { "name": 100 }], []);
    const { changePageSize, goToNextPage, goToPreviousPage, totalRecord } = props;

    const noOfPageDropdown = useCallback(() => {
        if (totalRecord <= 10) setPageSizeList(pageSizeLst.slice(0, 1))
        else if (totalRecord > 10 && totalRecord <= 25) setPageSizeList(pageSizeLst.slice(0, 2))
        else if (totalRecord > 25 && totalRecord <= 50) setPageSizeList(pageSizeLst.slice(0, 3))
        else setPageSizeList(pageSizeLst.slice(0, 4))

    }, [pageSizeLst, totalRecord])
    useEffect(() => {
        noOfPageDropdown()
    }, [noOfPageDropdown]);


    const goToPreviousPageHandler = useCallback((page: any) => {
        goToPreviousPage(page);
    }, [goToPreviousPage]);

    const goToNextPageHandler = useCallback((page: any) => {
        goToNextPage(page);
    }, [goToNextPage])

    useEffect(() => {
        if (pageSize) {
            changePageSize(pageSize);
        }
    }, [changePageSize, pageSize]);

    const handleChangePageSize = useCallback((value: any) => {
        setPageSize(value);
    }, []);

    const safeTotalPage = Number.isFinite(props.totalPage as number) && (props.totalPage as number) > 0
        ? props.totalPage
        : 1;
    const safeTotalRecord = typeof props.totalRecord === 'number' && props.totalRecord >= 0
        ? props.totalRecord
        : 0;

    return (
        <div className={`dx-theme-background-color pagination-cover`}>

            <div className="total-result">
                <div className="total-size">
                    <p className='dx-theme-text-color'>Showing {props.currentPageNo} of {safeTotalPage} pages ({safeTotalRecord} records)</p>
                    {props.showPageSize && <div className="filter-box pagination-pageSize">
                        {/* <TextField
                            id="outlined-select-currency-native"
                            select
                            label="Page Size"
                            className="select-field page-size-select-field"
                            margin="normal"
                            variant="outlined"
                            value={props.pageSize}
                            onChange={(event: any) => { changePageSize(event.target.value) }}
                        >
                            {pageSizeList.map((item, index) => (
                                <MenuItem key={`pageSize_${index}`} value={item.name}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </TextField> */}
                        <SelectBox
                            stylingMode='outlined'
                            items={pageSizeList}
                            displayExpr='name'
                            valueExpr='name'
                            value={props.pageSize ? props.pageSize : defaultPageSize}
                            defaultValue={defaultPageSize}
                            onValueChange={(e) => handleChangePageSize(e)}
                            height={"35px"}
                        />

                    </div>}
                </div>
                <Pagination>
                    <Pagination.Item
                        onClick={() => {
                            if (props.currentPageNo > 1)
                                goToPreviousPageHandler(1)
                        }}
                        disabled={props.currentPageNo === 1}

                    >
                        First Page
                    </Pagination.Item>

                    <Pagination.Prev
                        onClick={() => {
                            if (props.currentPageNo !== 1) {
                                let page = props.currentPageNo - 1;
                                goToPreviousPageHandler(page)
                            } else {
                                goToPreviousPageHandler(props.currentPageNo)
                            }
                        }}
                        disabled={props.currentPageNo === 1}
                    />

                    <Pagination.Item disabled>{props.currentPageNo}</Pagination.Item>

                    <Pagination.Next
                        onClick={() => {
                            if (!props.isLessthanTotalElement && (props.currentPageNo < safeTotalPage)) {
                                let page = props.currentPageNo + 1;
                                goToNextPageHandler(page)
                            }
                            else {
                                goToNextPageHandler(props.currentPageNo);
                            }
                        }}
                        disabled={(props.currentPageNo === safeTotalPage)}
                    />
                    <Pagination.Item
                        onClick={() => {
                            if (props.currentPageNo < safeTotalPage)
                                goToNextPageHandler(safeTotalPage)
                        }}
                        disabled={(props.currentPageNo === safeTotalPage)}
                    >
                        Last Page
                    </Pagination.Item>
                </Pagination>

            </div>

        </div>
    )
}


export default React.memo(PagingComponent);

interface ItemListProps {
    goToPreviousPage?: any;
    goToNextPage?: any;
    changePageSize?: any;
    isLessthanTotalElement?: boolean;
    pageSize?: number;
    currentPageNo?: number;
    totalPage?: number;
    totalRecord?: number;
    showPageSize?: boolean;
}


PagingComponent.defaultProps = {
    showPageSize: true
}


